import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, DateInsertFormat, DropdownPageSizeOptions, DropdownStatusList, DropdownTransactionStatus, DropdownTransactionType, EmptyString, FormTypeAdd, FormTypeEdit, FormTypeView, PageSize, PaginationBack, PaginationFirst, PaginationLast, PaginationNext, StatusCodeActive, StatusCodeDelete } from "utils/Constant";
import { ApiGetTransactionList, ApiGetUserLocationByUserId } from "utils/constants/api";
import useFetch from "utils/hooks/useFetch";
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import moment from "moment";
import PrintButton from "components/Button/PrintButton";
import SalesReportPdf from "components/modal/components/SalesReportGenerator";
import { ChevronRight } from "lucide-react";

export default function Report(){
    let navigate = useNavigate()

    const { data: transactionList, fetch: getTransactionList } = useFetch(ApiGetTransactionList)
    const { fetch: apiGetLocation } = useFetch(ApiGetUserLocationByUserId)

    const [locationOptions, setLocationOptions] = useState([])
    const [location, setLocation] = useState('1')
    const [firstLoad, setFirstLoad] = useState(true)

    const [vehicleModel, setVehicleModel] = useState(EmptyString)
    const [transactionType, setTransactionType] = useState(DropdownTransactionType[3].value)
    const [transactionStatus, setTransactionStatus] = useState(DropdownTransactionStatus[0].value)
    const [dateFrom, setDateFrom] = useState(new Date())
    const [dateTo, setDateTo] = useState(new Date())
    const [licensePlateNumber, setLicensePlateNumber] = useState(EmptyString)
    const [vehicleBrandOptions, setVehicleBrandOptions] = useState(JSON.parse(localStorage.getItem("VehicleBrand")))
    const [vehicleBrand, setVehicleBrand] = useState(EmptyString)
    const [status, setStatus] = useState(DropdownStatusList[1].value)
    const [pageSize, setPageSize] = useState(DropdownPageSizeOptions[0].value)
    const [salesFormModal, setSalesFormModal] = useState({ isOpen: false, transactionId: 0, locationId: 0, formType: FormTypeEdit, data: {} })
    const [isSummaryOpen, setIsSummaryOpen] = useState(false)

    // Grid
    const[paginationOptions, setPaginationOptions] = useState([])
    const[pageIndex, setPageIndex] = useState("")
    const[totalPageCount, setTotalPageCount] = useState(0)

    // Modal
    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
	const [loading, setLoading] = useState({isOpen: false})
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })

    // Event
    const salesFormModalClose = () => {
        setSalesFormModal({ isOpen: false, transactionId: 0 })
        fBindGrid(pageIndex, pageSize)
    }
    const transactionTypeChange = (e) => {
        setTransactionType(e.value)
    }
    const dateFromChange = (e) => {
        if(e === null){
            setDateFrom(new Date())
        }else{
            setDateFrom(e)
        }
    }
    const dateToChange = (e) => {
        if(e === null){
            setDateTo(new Date())
        }else{
            setDateTo(e)
        }
    }
    const pageSizeChange = (e) => {
        setPageSize(e.value)
    }
    
    // Button Event
    const addBtnClick = () => {
        navigate("/user/form?userId=&formType=" + FormTypeAdd)
    }
    const printBtnClick = () => {
        // Get New Data with no Page Size Limitation
        getTransactionListForPrint().then((sourceData) => {
            if (sourceData !== null) {
                console.log(sourceData)
                if (sourceData.data.listData.length > 0) {
                    let listData = sourceData.data.listData

                    const sampleData = listData
                    const data = [...sampleData]

                    const date1 = moment(dateFrom).format('DD MMMM YYYY')
                    const date2 = moment(dateTo).format('DD MMMM YYYY')
                    const locName = locationOptions.find(x => x.value === location).label

                    SalesReportPdf(data, date1, date2, location, transactionType, locName)
                } else {
                    setFailModal({
                        isOpen: true,
                        data: {
                            onSuccess: async () => {
                                setFailModal({isOpen: false})
                            }
                        },
                        message: "No Data Available"
                    })
                }
            }
        })
    }
    const transactionDataClick = (id, locationId) => {
        setSalesFormModal({ isOpen: true, transactionId: id, locationId: locationId, formType: FormTypeView  })
    }

    // Function Api Call
    const getTransactionListForPrint = async() => {
        let res = await getTransactionList({
            data: {
                dateFrom: moment(dateFrom).format(DateInsertFormat),
                dateTo: moment(dateTo).format(DateInsertFormat),
                locationId: location === EmptyString ? 0 : location,
                transactionType: parseInt(transactionType === EmptyString ? 0 : transactionType),
                licensePlateNumber,
                vehicleBrand: vehicleBrand === null || vehicleBrand === EmptyString ? 0 : (vehicleBrand.value === EmptyString || vehicleBrand.value === null ? 0 : parseInt(vehicleBrand.value)),
                employeeName: EmptyString,
                vehicleModel,
                status,
                transactionStatus,
                pageSize: 100000,
                pageIndex: 0
            }
        })
        return res
    }
    async function fGetTransactionList(i){
        let res
        
        await getTransactionList({
            data: {
                dateFrom: moment(dateFrom).format(DateInsertFormat),
                dateTo: moment(dateTo).format(DateInsertFormat),
                locationId: location === EmptyString ? 0 : location,
                transactionType: parseInt(transactionType === EmptyString ? 0 : transactionType),
                licensePlateNumber,
                vehicleBrand: vehicleBrand === null || vehicleBrand === EmptyString ? 0 : (vehicleBrand.value === EmptyString || vehicleBrand.value === null ? 0 : parseInt(vehicleBrand.value)),
                employeeName: EmptyString,
                vehicleModel,
                status,
                transactionStatus,
                pageSize: pageSize === EmptyString ? 10000000 : pageSize,
                pageIndex: i
            }
        }).then((response) => {
            if (checkResponse(response)) {
                res = response
            }
        })
        return res
    }
    async function fGetLocationList(){
        await apiGetLocation({
            data: {
                userId: localStorage.getItem('Id')
            }
        }).then((response) => {
            if (checkResponse(response)) {
                let tempArray = []
                tempArray.push({label: "All", value: ""})

                for (let i = 0; i < response.data.length; i++){
                    tempArray.push({ label: response.data[i].locationName, value: String(response.data[i].locationId) })
                }

                setLocationOptions(tempArray)
                setLocation(tempArray[0].value)
            }
        })
    }

    // Function Grid
    async function fBindGrid(index){
        setLoading({isOpen: true})

        let i = index !== null ? (index !== "" ? parseInt(index) : 0) : 0

        fGetTransactionList(i).then((res) => {
            if (res !== null && typeof(res) !== "undefined"){
                let totalData = res.data.totalData
                fSetPaginationOptions(totalData, index)
            }
            setLoading({isOpen: false})
        })   
    }
    function fSetPaginationOptions(dataCount, index){
        let numberOfPage = parseInt(parseInt(dataCount)/PageSize)
        let array = []
        
        setTotalPageCount(numberOfPage = 0 ? 1 : numberOfPage)

        for (let i = 0; i <= numberOfPage; i++){
            array.push({
                label: String(i + 1),
                value: String(i)
            })
        }
        
        setPaginationOptions(array)
        
        if(index !== "" && index !== null){
            setPageIndex(String(index))
        }else{
            setPageIndex("0")
        }
    }
    function fPaginationBtnClick(command){
        if(command === PaginationFirst){
            setPageIndex("0")
            fBindGrid(0)
        }else if(command === PaginationBack){
            let index = parseInt(pageIndex) - 1

            if(index >= 0){
                setPageIndex(index)
                fBindGrid(index)
            }
        }else if(command === PaginationNext){
            let index = parseInt(pageIndex) + 1

            if (totalPageCount >= index){
                setPageIndex(index)
                fBindGrid(index)
            }
        }else if(command === PaginationLast){
            let index = totalPageCount

            setPageIndex(index)
            fBindGrid(index)
        }
    }
    function fPaginationIndexChange(index){
        setPageIndex(index)
        fBindGrid(index)
    }

    const checkResponse = (res) => {
        if(res.status === ApiResponseSuccess){
            return true
        }else if(res.status === ApiResponseStatusUnauthorized){
            setFailModal({
                isOpen: true,
                data: {
                    onSuccess: async () => {
                        setFailModal({isOpen: false})
                        window.location.href = "/login"
                    }
                },
                message: res.message
            })
            return false
        }else{
            setFailModal({
                isOpen: true,
                data: {
                    onSuccess: async () => {
                        setFailModal({isOpen: false})
                    }
                },
                message: res.message
            })
            return false
        }
    }

    return(
        <div className="flex flex-col gap-2">
            <div >
                <span className="font-semibold text-2xl">Report</span>
            </div>
            <hr />

            <div className="w-full">
                <a href="/report/daily-report" className="w-full flex justify-between items-center bg-white h-11 px-4 rounded-full border hover:bg-slate-300 transition-all">
                    <span>Laporan Harian</span>
                    <ChevronRight className="w-4" />
                </a>
            </div>
            
        </div>
    )
}

const FilterCard = ({title, children}) => {
    return (
        <div className="flex flex-col gap-1 w-full sm:w-[280px] text-sm sm:text-base">
            <span>{title}</span>
            {children}
        </div>
    )
}